/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid } from '@material-ui/core';
import { Table, Filtro } from '../../components';
import * as selectorsMalhas from '../../store/malha/reducer';
import * as actionsMalhas from '../../store/malha/actions';
import Formulario from './Formulario';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const Malhas = ({ malhas, loadMalhas, deleteMalha }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  
  const classes = useStyles();
  
  const renderRows = d => {
    return (
      <>
        <TableCell>{d.codigo}</TableCell>
        <TableCell>{d.nome}</TableCell>
      </>
    )
  }

  useEffect(() => {
    loadMalhas()
  }, [loadMalhas]);

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onDelete = id => deleteMalha(id);
  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = (isSave) => {
    if (isSave) {
      loadMalhas();
    }
    setOpen(false);
    setId(null);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Filtro 
          onFilter={filterData => loadMalhas(filterData)}
          useCodigo
        />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          rows={malhas}
          titles={['Código', 'Nome']}
          headerTitle="Malhas"
          renderRows={renderRows}
          hasRowActions
          onEdit={onEdit}
          onDelete={onDelete}
          showDelete={false}
          onAdd={onAdd}
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          malhas={malhas}
        />
      </Grid>
    </Grid>
    );
};

Malhas.propTypes = {
  deleteMalha: PropTypes.func.isRequired,
  loadMalhas: PropTypes.func.isRequired,
  malhas: PropTypes.array,
};

const mapStateToProps = state => ({
  malhas: selectorsMalhas.getMalhas(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsMalhas
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Malhas));